import { get, update } from 'lodash'
import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import Errors from '@shared/error/errors';
import { i18n } from '@shared/i18n';

const stripePaymentFeesByCountry = require(`@enums/stripePaymentFeesByCountry.json`)

const feeContryType = { 
  EUROPEAN: 'EUROPEAN',
  NON_EUROPEAN: 'NON_EUROPEAN',
  COUNTRY: 'COUNTRY',
  INTERNATIONAL: 'INTERNATIONAL',
}

const ConfigFeesInfo =  {
  EUROPEAN: {
      info: `${i18n('entities.subprogram.form.payment.fee.forEuropean')}`,
  },
  NON_EUROPEAN:{
      info: `${i18n('entities.subprogram.form.payment.fee.forNonEuropean')}`,
  },
  COUNTRY: {
      info: `${i18n('entities.subprogram.form.payment.fee.forCountry')}`,
  },
  INTERNATIONAL: {
      info: `${i18n('entities.subprogram.form.payment.fee.forInternational')}`,
  }
}
export default {
  namespaced: true,

  state: {
    loading: false,
    feeList: [],
    country: null,
  },

  getters: {
    country: (state) => state.country,
    feeList: (state) => state.feeList,
    loading: (state) => !!state.loading,
  },

  mutations: {
    SET_COUNTRY(state, payload) {
      state.country = payload;
    },
    FIND_STARTED(state) {
      state.feeList = [];
      state.loading = true;
    },

    FIND_SUCCESS(state,  feeList) {
      state.loading = false;
      state.feeList = feeList;
    },

    FIND_ERROR(state) {
      state.feeList = [];
      state.country = null;
      state.loading = false;
    },
  },

  actions: {
    async doLoadFeeList({ commit }, { subpropertyId } ) {
      try {
        commit('FIND_STARTED');
        const stripeData = await SubpropertyService.stripeData({ subpropertyId });
        const amountOwqlo = get(stripeData, 'owqloFee.fixedAmount', 0);
        const percentageOwqlo = get(stripeData, 'owqloFee.percentage', 0);
        const defaultCurrency = get(stripeData, 'connectedAccount.defaultCurrency', null);
        const country = get(stripeData, 'connectedAccount.address.country', null);
        const stripeFeesByCountry = get(stripePaymentFeesByCountry, `${country}`, []);

        const feeList = stripeFeesByCountry.map(({ type, amount, percentage }) => { 
            let feeObject = {}

            if (type === feeContryType.EUROPEAN) {
                feeObject = Object.assign({}, ConfigFeesInfo.EUROPEAN);
            } else if (type === feeContryType.NON_EUROPEAN) {
                feeObject = Object.assign({}, ConfigFeesInfo.NON_EUROPEAN);
            } else if (type === feeContryType.COUNTRY) {
                feeObject = Object.assign({}, ConfigFeesInfo.COUNTRY);
            } else if (type === feeContryType.INTERNATIONAL) {
                feeObject = Object.assign({}, ConfigFeesInfo.INTERNATIONAL);
            }

            const amountTotal = (amount + amountOwqlo);
            const percentageTotal = percentage + percentageOwqlo;

            update(feeObject, 'type', () => type);
            update(feeObject, 'amount', () => amountTotal);
            update(feeObject, 'currency', () => defaultCurrency);
            update(feeObject, 'percentage', () => percentageTotal);

            return feeObject;
        })

        commit('FIND_SUCCESS', feeList);
        commit('SET_COUNTRY', country);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
      }
    },
  },
};
